import { FiltersConfigTemplateElement } from "PFTypes/filters_config";
import { useMemo } from "react";

export const useDefaultFilterFields = (template: FiltersConfigTemplateElement) =>
  useMemo(
    () =>
      [...Object.keys(template.inputs), "name"].reduce((acc, property) => {
        switch (template.inputs[property]?.type) {
          case "checkbox": {
            acc[property] = false;
            break;
          }
          case "string":
          case "number": {
            acc[property] = "";
            break;
          }
          default: {
            acc[property] = null;
            break;
          }
        }
        return acc;
      }, {}),
    [template]
  );
